import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import { portraits } from '../../portraits';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import './style.css';

function About() {
  return (
    <section id="portraits" className="content-section portraits-section">
      <div className="section-heading">
        <div>
          <span className="eyebrow">In frame</span>
          <h2>Portraits</h2>
        </div>
        <span className="section-heading-note">A closer look at Paige</span>
      </div>
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        spaceBetween={16}
        slidesPerView={1.22}
        breakpoints={{ 600: { slidesPerView: 2.2, spaceBetween: 20 }, 1000: { slidesPerView: 3.2, spaceBetween: 24 } }}
        className="portrait-swiper"
      >
        {portraits.map((src, index) => (
          <SwiperSlide key={src}>
            <img src={src} alt={`Portrait of Paige Faure ${index + 1}`} loading="lazy" />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
}

export default About;
